import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { editroomType, getroomType } from "../store/slices/roomType";
import { nameregex } from "../helper/regex";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import { GrUploadOption } from "react-icons/gr";

const EditRoomTypes = () => {
  const { id } = useParams();
  let user = JSON.parse(localStorage.getItem("users"));
  const token = user.data.accessToken;
  const [name, setName] = useState("");
  const [imageUrl, setimageUrl] = useState("");
  const [imageError, setImageError] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPlaceDetails = async () => {
      try {
        let item = { id };
        const data = await dispatch(getroomType(item)).unwrap();
        const place = data?.roomTypeData[0];

        if (place) {
          setName(place.name || "");
          setimageUrl(place.imageUrl || "");
        }
      } catch (error) {
        console.error("Failed to fetch room type details:", error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPlaceDetails();
  }, [dispatch, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    switch (name) {
      case "name":
        setName(value);
        validationErrors[name] =
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter a valid room type"
            : "";
        break;

      default:
        break;
    }

    setErrors(validationErrors);
  };

  const EditRoomTypes = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 3000);

    const validationErrors = {};

    // Validate name
    if (!name.trim()) {
      validationErrors.name = "Please enter room type";
    } else if (!nameregex.test(name)) {
      validationErrors.name = "Room type  must be at least three characters";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const item = {
      name,
      imageUrl,
      id,
    };

    try {
      await dispatch(editroomType(item)).unwrap();
      alert("Room type details updated successfully!");
      navigate("/admin/room-types");
    } catch (error) {
      alert(error);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  async function imageUpload(e) {
    setImageError("");
    const file = e.target.files[0];

    if (file.size > 5 * 1024 * 1024) {
      setImageError("Please upload an image less than 5 MB");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        "x-access-token": token,
      },
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}${API_PATHS.uploadFile}`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`Upload failed with status: ${response.status}`);
      }

      const data = await response.json();

      if (data?.status === 1 && data?.data?.location) {
        const uploadedImageUrl = data.data.location;
        setimageUrl(uploadedImageUrl);
        setErrors((prevErrors) => ({ ...prevErrors, image: "" }));
      } else {
        throw new Error(data.message || "Failed to upload image");
      }
    } catch (error) {
      console.error("Image Upload Error:", error.message);
      setImageError(
        error.message || "Something went wrong while uploading the image"
      );
    }
  }

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Edit Room Type</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/room-types"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Room Type
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Edit Room Type</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form onSubmit={EditRoomTypes}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Room Type <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={name}
                  onChange={handleChange}
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  placeholder="Enter Room Type"
                />
                {errors.name && (
                  <div className="text-danger mt-2">{errors.name}</div>
                )}
              </div>

              <div className="col-md-5">
                <label className="form-label">Image</label>
                <br />
                <label htmlFor="fileInput" className="custom-button">
                  <GrUploadOption
                    style={{ fontSize: "16px", lineHeight: "18px" }}
                  />
                  &nbsp; Upload Image
                </label>
                <input
                  type="file"
                  id="fileInput"
                  accept="image/*"
                  name="imageUrl"
                  onChange={imageUpload}
                  className={`form-control ${imageError ? "is-invalid" : ""}`}
                />
                {errors.image && (
                  <div className="text-danger mt-2">{errors.image}</div>
                )}
                <br />
                <img
                  className="mt-3"
                  src={imageUrl}
                  style={{ height: "60px" }}
                  alt=""
                />
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditRoomTypes;
